import { uniqBy } from 'lodash';
import { SimpleObject } from '~src/types';
import { DbFolder } from '~src/types/db';
import { FileX } from '~src/types/upload';

export const buildFileLocation = (
  file: FileX,
  currentFolder?: DbFolder
): string => {
  let location = '';

  // add current folder name
  if (currentFolder) location += currentFolder.name + '/';

  // for folder upload, parse `webkitRelativePath`
  // `webkitRelativePath` seems to end in file.name for most browsers, so remove that
  if (file.webkitRelativePath) {
    if (file.webkitRelativePath.endsWith(file.name)) {
      location += file.webkitRelativePath.slice(
        0,
        file.webkitRelativePath.lastIndexOf('/') + 1
      );
    } else {
      location += file.webkitRelativePath + '/';
    }
  }

  return location || '/';
};

type PathGroup = string[][];
/** Returns complete `groups` object, with missing path levels
 *
 * @param groups - initial path groups
 */
export const insertMissingPathLevels = (
  groups: SimpleObject<PathGroup>
): SimpleObject<PathGroup> => {
  const nextGroups = { ...groups };

  /** represents highest level */
  const maxKey = Math.max(
    ...Object.keys(groups).map((key) => {
      const num = Number(key);
      if (!num) throw new Error('Bad input');
      return Number(key);
    })
  );

  // can only miss levels if u have at least 2
  if (maxKey < 2) return nextGroups;

  for (let i = maxKey - 1; i > 0; i--) {
    // missing level
    const downLevelItems = nextGroups[i + 1].map((_groups) =>
      _groups.slice(0, -1)
    );

    // keep unique paths
    nextGroups[i] = uniqBy([...(nextGroups[i] || []), ...downLevelItems], (v) =>
      v.join()
    );
  }

  return nextGroups;
};
